<template>
  <el-dialog
      v-el-drag-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      append-to-body
      title="选择销售订单"
      width="1280px"
      top="8vh">
    <table-select
        ref="tableSelect"
        :filter="filter"
        :columns="columns"
        module="basic"
        url="sd/so/ma/page"
        height="500"
        @select="salesOrderSelect"
        @reset="resetHandle">
      <template slot="adSearch">
        <el-form ref="form" :inline="true" :model="filter">
          <el-form-item label="关键字" prop="filter">
            <el-input v-model.trim="filter.filter" placeholder="请输入关键字" clearable/>
          </el-form-item>
        </el-form>
      </template>
    </table-select>
    <span slot="footer">
      <el-button @click="dialogVisible = false">取消</el-button>
      <el-button type="primary" @click="submitHandle">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
  import TableSelect from "@/components/TableSelect.vue";

  export default {
    components: {TableSelect},
    data() {
      return {
        dialogVisible: false,
        filter: {
          filter: "",
          salesOrderNo: "",
          customerContractNo: "",
          deliveryStatus: 10,
          invoiceStatus: 20,
        },
        selections: [],
        columns: [
          {
            type: "selection",
            width: 60,
            align: "center",
          },
          {
            title: "销售单号",
            key: "salesOrderNo",
            width: 140,
            align: "center",
          },
          {
            title: "客户名称",
            key: "customerName",
          },
          {
            title: "行号",
            key: "rowIndex",
            width: 80,
          },
          {
            title: "物料编号",
            key: "materialNo",
          },
          {
            title: "物料名称",
            key: "materialName",
          },
          {
            title: "要求交期",
            key: "deliveryDate",
          },
          {
            title: "数量",
            key: "quantity",
          },
          {
            title: "已发数量",
            key: "shippedQuantity",
          },
        ],
      };
    },
    methods: {
      open() {
        this.dialogVisible = true;
        this.$nextTick(() => {
          this.$refs.form.resetFields();
          this.$refs.tableSelect.loadData();
        });
      },

      salesOrderSelect(selections) {
        this.selections = selections;
      },
      submitHandle() {
        this.$emit("select", this.selections);
        this.dialogVisible = false;
      },
      resetHandle(filter) {
        this.filter = Object.assign(this.filter, filter);
        this.$nextTick(() => {
          this.$refs.tableSelect.loadData();
        });
      },
    },
  };
</script>
